import { graphql } from "@/lib/gql/__generated__";

export const ContactList = graphql(/* GraphQL */ `
	query ContactList($hotelID: ID!) {
		contactList(hotelID: $hotelID) {
			id
			hotelID
			contacts {
				id
				hotelID
				contactID
				reservationID
				contactGenre
				title
				messages {
					message
					images {
						bucket
						key
						region
						mimeType
						fileName
					}
					senderType
					createdAt
				}
			}
		}
	}
`);
